import { appConfig } from 'brand-config';

import { CognitoPermissionGroups } from 'core/helpers/cognito-permission-groups';
import { isEnvScopedFlagEnabled } from 'core/helpers/env-scoped-flag';

/**
 * FormField permission override for the sweep-account forms. The page is only reachable
 * with the CanManageSweepAccount group, so field editability keys off that same group —
 * not the default canEdit, which agency users don't have.
 */
export const sweepAccountFieldPermissions = {
  edit: { groups: [CognitoPermissionGroups.canManageSweepAccount] }
};

/**
 * Agency sweep accounts (#33155) are gated per-brand AND per-environment, so a mutual can pilot
 * the feature in dev/staging while it stays off in production. Currently on in every env for all
 * brands.
 */
export const isSweepAccountsEnabled = () => isEnvScopedFlagEnabled(appConfig?.featureFlags?.sweepAccounts);

/**
 * Type-level label for a sweep account payment method: the bank name for an ACH
 * (`us_bank_account`) method, falling back to "Bank account", or the card brand otherwise,
 * falling back to "Card". Shared by the sweep-bind dropdown and the Sweep Account management
 * list so the type→label mapping lives in one place; each caller appends its own last-4
 * formatting (the dropdown marks the default; the management list uses a "••••"/"????" style).
 */
export const sweepPaymentMethodTypeLabel = (pm) =>
  pm.type === 'us_bank_account' ? pm.bankName || 'Bank account' : pm.brand || 'Card';
